<template>
  <div class="group-setup">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Service Project Approved Points</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-row v-if="data && data.projectApprovedPoints">
        <v-col cols="12" md="12" sm="12">
          <ApprovedPoints :points="data.projectApprovedPoints"></ApprovedPoints>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ApprovedPoints from "../child/ApprovedPoints";
export default {
  name: "ApprovedPointList",
  props: ["data"],
  components: { ApprovedPoints },

  data: () => ({
    role: localStorage.getItem('role') || null
  }),

  mounted() { },

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },

  },
};
</script>
